<template>
  <div class="one-timings mb-3">
    <div class="one-timings-info-block">
      <div class="one-timings-info-block-name">Создана</div>
      <div class="one-timings-info-block-icon">
        <i class="bi bi-check-circle-fill text-success"></i>
      </div>
      <div class="one-timings-info-block-value">
        <span>{{ formatDateTime(model.create_time) }}</span>
      </div>
    </div>
    <div class="one-timings-info-block-separator">
      <i class="bi bi-arrow-right"></i>
    </div>
    <div class="one-timings-info-block">
      <span class="one-timings-info-block-name">Решена</span>
      <div class="one-timings-info-block-icon">
        <i v-if="model.is_done" class="bi bi-check-circle-fill text-success"></i>
        <i v-else class="bi bi-play-circle-fill"></i>
      </div>
      <div class="one-timings-info-block-value">
        <span v-if="model.is_done">{{ formatDateTime(model.done_time) }}</span>
        <span v-else>В работе...</span>
      </div>
    </div>
    <div class="one-timings-info-block-separator">
      <i class="bi bi-arrow-right"></i>
    </div>
    <div class="one-timings-info-block">
      <span class="one-timings-info-block-name">Синхр.</span>
      <div class="one-timings-info-block-icon">
        <i v-if="model.synchronizating" class="spinner-border spinner-border-sm"><span class="visually-hidden">Синхронизация...</span></i>
        <i v-else-if="model.sync_time && model.sync_time >= model.done_time" class="bi bi-check-circle-fill text-success"></i>
        <i v-else class="bi bi-x-circle-fill text-danger"></i>
      </div>
      <div class="one-timings-info-block-value">
        <span v-if="model.synchronizating">Синхронизация...</span>
        <span v-else-if="model.sync_time">{{ formatDateTime(model.sync_time) }}</span>
        <span v-else>Не загружалось с устройства</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateTime } from "@/helpers/format_date";

export default {
  props: [
      'model'
  ],
  methods: {
    formatDateTime(timestamp) {
      return formatDateTime(timestamp);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/scss/list.scss";
</style>